import React from 'react';
import { useAccount } from '@/hooks/useAccount';
import { useQuery } from '@apollo/client/react';
import COUNT_SUB_ACCOUNTS_Q from '../gql/countSubAccounts.gql';

import { MainView } from '@repo/ui/Views';
import SubAccountsTable from '../components/SubAccountsTable';
import RedirectToAccountOverview from '@/features/account_overview/components/RedirectToAccountOverview';
import { POLICIES } from '@/lib/Authorization';
import { useUser } from '@repo/hooks/useUser';
import { AccountFlagOverrideBehaviour } from '@repo/types/Models';

const SubAccounts = () => {
  const account = useAccount();
  const accountId = account.id;
  const user = useUser();

  // const { data: countData } = useQuery(COUNT_SUB_ACCOUNTS_Q);

  // console.log('countData', countData);
  // console.log('account', account);
  //   const currentCount = countData?.countSubAccounts?.count ?? 0;

  //   const accountMaxSubAccountBehaviour = account.overrideMaxSubAccounts;
  //   const accountPlanMaxSubAccounts = account.servicePlan?.maxSubAccounts;

  //   const accountMaxSubAccounts =
  //     accountMaxSubAccountBehaviour === AccountFlagOverrideBehaviour.PLAN_ONLY
  //       ? accountPlanMaxSubAccounts
  //       : account.maxSubAccounts;

  //   const hasReachedLimit =
  //     typeof accountMaxSubAccounts === 'number' &&
  //     accountMaxSubAccounts !== -1 &&
  // currentCount >= accountMaxSubAccounts;
  // const canCreateSubAccounts =
  //   POLICIES['accounts:create'](user) && !hasReachedLimit;

  const canCreateSubAccounts = POLICIES['accounts:create'](user);

  return (
    <MainView
      title="Sub Accounts"
      cta={
        canCreateSubAccounts
          ? {
              cta: true,
              ctaHref: `/a/${accountId}/sub-accounts/create-sub-account`,
              ctaText: 'Create new sub account',
            }
          : false
      }
    >
      {account.parentAccount ? (
        <RedirectToAccountOverview />
      ) : !accountId ? (
        <p>No account id provided</p>
      ) : (
        <SubAccountsTable
          accountId={Array.isArray(accountId) ? accountId[0] : accountId}
          // maxAccountSubAccountsCount={accountMaxSubAccounts}
        />
      )}
    </MainView>
  );
};

export default SubAccounts;
